<template>
  <div class="tableau-de-bord">
    <v-row v-if="!loading?.grainesRs3 && cultures.length > 0">
      <BlocCulture
        v-if="isCulture"
        :annee-selected="anneeSelected"
        :graines-selected="grainesSelected"
        :code-graine-selected="codeGraineSelected"
        :has-regions="hasRegions"
      />
      <BlocGlobal
        v-if="isTous"
        :synthese="synthese"
        :annee-selected="anneeSelected"
        :code-graine-selected="codeGraineSelected"
      />
    </v-row>
  </div>
</template>

<script>

import BlocCulture from './bloc-culture.vue'
import BlocGlobal from './bloc-global.vue'

export default {
  name: 'TableauDeBordOutilsAnalyse',

  components: {BlocCulture, BlocGlobal},
  props: {
    anneeSelected: {
      type: String,
      default: null
    },
    codeGraineSelected: {
      type: String,
      default: null
    },
    grainesSelected: {
      type: Array,
      default: null
    },

    loading: {
      type: Object,
      default: () => ({
        grainesRs3: false,
        synthese: false
      })
      },
    cultures: {
      type: Array,
      default: () => []
    },

    synthese: {
      type: Array,
      default : () => []
    },

    filtres: {
      type: Object,
      default: () => ({})
    },
    hasRegions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dashboardKey () {
      return `${this.anneeSelected}-${this.codeGraineSelected}`
    },

    isTous () {
      return this.codeGraineSelected === 'Tous'
    },

    isCulture () {
      return this.codeGraineSelected && this.codeGraineSelected !== 'Tous'
    }
  }
}
</script>

<style lang="scss" scoped>

.tableau-de-bord ::v-deep .row > .row {
  min-width: 0;
}
</style>
